$(function() {
	var sendHandlers = [
		{
			name: 'handleSymbolClick',
			linkClass: 'a.symbol-link',
			parameter: 'PROFILE',
			data: 'symbol'
		},
		{
			name: 'handleMutualFundProfileClick',
			linkClass: 'a.mf-profile-link',
			parameter: 'MFPROFILE',
			data: 'symbol'
		},
		{
			name: 'handleNewsClick',
			linkClass: 'a.news-link',
			parameter: 'NEWS',
			data: 'newsId'
		},
		{
			name: 'handleFullChartClick',
			linkClass: 'a.fullchart-link',
			parameter: 'FULLCHART',
			data: 'symbol'
		},
		{
			name: 'handleQuoteClick',
			linkClass: 'a.quote-link',
			parameter: 'QUOTE',
			data: 'symbol'
		},
		{
			name: 'handleQuoteTypeClick',
			linkClass: 'a.quotetype-link',
			parameter: 'quoteType',
			data: 'quoteType'
		},
		{
			name: 'handleTradeStockClick',
			linkClass: 'a.trd-stock-link',
			parameter: 'TRDSTOCK',
			data: 'symbol'
		},
		{
			name: 'handleTradeMutualFundClick',
			linkClass: 'a.trd-mf-link',
			parameter: 'TRDMF',
			data: 'symbol'
		},
        {
			name: 'handleTradeOptionClick',
			linkClass: 'a.trd-option-link',
			parameter: 'TRDOPTION',
			data: 'symbol'
		},
		{
			name: 'handleAddToWatchlist',
			linkClass: 'a.add-to-watchlist-link',
			parameter: 'ADDWATCH',
			data: 'symbol'
		},
		{
			name: 'handleWatchlists',
			linkClass: 'a.watchlists-link',
			parameter: 'WATCHLISTS'
		},
		{
			name: 'handleSetAlertClick',
			linkClass: 'a.set-alert-link',
			parameter: 'SETALERT',
			data: 'symbol'
		},
		{
			name: 'handleProspectusClick',
			linkClass: 'a.prospectus-link',
			parameter: 'PROSPECTUS',
			data: 'cusip'
        },
        {
            name: 'handleIntLink',
            linkClass: 'a.int-link',
            parameter: 'INTLINK',
            data: 'intlink'
        }
	];

	var redirectHandlers = [
		{
			name: 'handleRedirectClick',
			linkClass: 'a.redirect-link',
			parameter: 'urlkey',
			data: 'urlkey'
		}
	];

	var sendDisclosureHandlers =[
		{
			name: 'handleSendDisclosureClick',
			linkClass: 'a.send-disclosure-link',
			parameter: 'DISC',
			data: 'disclosuretype'
		}
	];

	function initSendHandlers() {
		var setHandler = function(evt, type, item) {
			evt.preventDefault();

			var $el = $(evt.target);
			var obj = {};
			
			//	WF-3999: This validation helps to avoid the issue when the link contains a <span> (or other) tag.
			if (!$el.is(item.linkClass)) {
				$el = $el.closest('a[data-' + item.parameter + ']');
			}

			obj[item.parameter] = item.data
				? $el.data(item.data)
				: '';

			if ($el.attr('uri')) {
				obj.uri = $el.attr('uri').toString();
			}

			return MOD.WfEasyXdm[type](obj);
		};

		sendHandlers.forEach(function(item) {
			$(document).on('click', item.linkClass, $.proxy(function(evt) {
				setHandler(evt, 'sendMessage', item);
			}, this));
		});
		
		redirectHandlers.forEach(function(item) {
			$(document).on('click', item.linkClass, $.proxy(function(evt) {
				setHandler(evt, 'redirectLink', item);
			}, this));
		});

		sendDisclosureHandlers.forEach(function(item) {
			$(document).on('click keypress', item.linkClass, $.proxy(function(evt) {
				evt.preventDefault();				
				if (evt.type === 'click' || (evt.type === 'keypress' && (evt.keyCode === 32 || evt.keyCode === 13))) {
					setHandler(evt, 'sendDisclosure', item);
				}
			}, this));
		});
	}

	initSendHandlers();
});
